<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600"
  >
    <v-card>
      <v-card-title>
        Helper
        <v-spacer />
        <v-btn
          icon
          @click="$emit('update:show', false)"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-tabs vertical>
        <v-tab>
          <v-icon left>
            mdi-font
          </v-icon>
          Fonts
        </v-tab>
        
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              --Add font helper here--
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: "TemplateHelper",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        };
    }
};
</script>